import React, { PureComponent } from 'react';
import PropTypes, { any } from 'prop-types';

import { drawPositionTypeIds } from '../../../../utils/eventConstants';
import BackgroundImage from '../../../BackgroundImage';
import Popup from '../../../Popup';
import { isPlayerCheckedIntoDraw } from '../../../../utils/events';

class PlayerLookupInputV2 extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            filterString: '',
            expand: false,
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleExpand = this.handleExpand.bind(this);
        this.handleCollapse = this.handleCollapse.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handleKeyUp = this.handleKeyUp.bind(this);
        this.handleExpandClick = this.handleExpandClick.bind(this);
        this.togglePopup = this.togglePopup.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleExpandClick() {
        if (this.props.warnBeforePlayerChange) {
            this.togglePopup();
        } else {
            this.handleExpand();
        }
    }

    handleExpand() {
        if (!this.props.isReadOnly) {
            this.setState({
                expand: true,
                filterString: '',
            },
            () => {
                setTimeout(this.inputRef.focus(), 10);
            });
        }
    }

    handleCollapse() {
        this.setState({ expand: false });
    }

    handleChange(e) {
        this.setState({ filterString: e.target.value });
    }

    handleKeyUp(e) {
        if (e.key === 'Escape') {
            this.handleCollapse();
        }
    }

    handleClickOutside(e) {
        if (!this.wrapperRef.contains(e.target)) {
            this.handleCollapse();
        }
    }

    togglePopup() {
        this.setState(prevState => ({
            showPopup: !prevState.showPopup,
        }));
    }

    render() {
        const {
            name,
            selectClass,
            parentClass,
            playerOptions,
            isReadOnly,
            showBye,
            position,
            onSelect,
            utrByMemberId,
            showTeamName,
            teamName,
            warnBeforePlayerChange,
            isMobile,
            PTTPosition,
            PTTError,
            drawId,
            'data-testid': dataTestId,
        } = this.props;

        const { expand, filterString, showPopup } = this.state;

        return (
            <div className={`card-player-select ${!isReadOnly ? 'allow-player-change' : ''} ${parentClass}`} ref={(el) => { this.wrapperRef = el; }}>
                <div className="input-wrapper">
                    <div
                        className={`player-select ${expand ? 'd-none' : 'd-block'} ${selectClass} ${PTTError ? 'text-danger' : ''}`}
                        onClick={() => { if (!isReadOnly) { this.handleExpandClick(); } }}
                        data-testid={dataTestId}
                    >{name} {!isReadOnly && <i className="uts uts-expand" />}
                    </div>
                    {expand && (
                        <>
                            <input
                                ref={(el) => { this.inputRef = el; }}
                                className={`player-select`}
                                value={filterString || ''}
                                onChange={this.handleChange}
                                onKeyUp={this.handleKeyUp}
                                placeholder="Type to filter players..."
                            />
                            <i className={`uts uts-collapse`} onClick={this.collapseList} />
                        </>
                    )}
                    {!!PTTPosition && <div className="ptt-position">{PTTPosition}</div>}
                </div>

                {expand && (
                    <div className={`select-options`}>
                        <ul>
                            {!!playerOptions.length && playerOptions.map(player => {
                                const regex = new RegExp(filterString, 'i');
                                const checkedInDraw = isPlayerCheckedIntoDraw(player, drawId);
                                return filterString && !(`${player.firstName} ${player.lastName}`).match(regex) ? null
                                    : (
                                        <li key={player.memberId} onClick={() => { this.handleCollapse(); onSelect(position, player); }}>
                                            <div className={`row player-search-option`}>
                                                <div className="col-2 d-flex justify-content-center">
                                                    <BackgroundImage
                                                        baseUrl={'/v1/player/'}
                                                        defaultImage={'/img/v2/icons/icon-avatar-player.svg'}
                                                        images={player.playerProfileImages}
                                                        imageType={'profile'}
                                                        parentStylesClass={'profile-image'}
                                                    />
                                                </div>
                                                <div className="col-10 d-block">
                                                    <div className="name">
                                                        <span>{player.firstName} {player.lastName}
                                                            <small> {utrByMemberId(player.memberId)}</small>
                                                        </span>
                                                        {checkedInDraw && <span className="utr-icon icon-check-mark-green ml4 checkin-mark" title="Player checked in" />}
                                                    </div>
                                                    <div className="place">{showTeamName && teamName ? teamName : player.location?.display}</div>
                                                </div>
                                            </div>
                                        </li>
                                    );
                            })}
                            {!playerOptions.length && (
                                <li className="mt16">No players to add...</li>
                            )}
                        </ul>
                        <div className="footer bt">
                            <div className="row no-gutters">
                                <div className={`${showBye ? 'col-6' : 'col-12'}`}>
                                    <div className="footer-button" onClick={() => { this.handleCollapse(); onSelect(position, null); }}>
                                        <i className="uts uts-clear-player" /> Clear
                                    </div>
                                </div>
                                {showBye && (
                                    <div className="col-6">
                                        <div className="footer-button bl" onClick={() => { this.handleCollapse(); onSelect(position, { typeId: drawPositionTypeIds.BYE }); }}>
                                            <i className="uts uts-player-bye" /> Bye
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}
                {showPopup && (
                    <Popup
                        onCloseClick={this.togglePopup}
                        className="popup-sm"
                        config={{
                            noPadding: false,
                            topGradient: true,
                            style: {
                                height: isMobile ? 180 : 160,
                                maxHeight: '80vh',
                            },
                        }}
                    >
                        <div>
                            <p className="fs15 text-center mb16">{warnBeforePlayerChange}</p>
                            <div className="row">
                                <div className="col-6 jcc">
                                    <button
                                        type="button"
                                        className="btn btn-md btn-primary btn-block"
                                        onClick={() => {
                                            this.togglePopup();
                                            this.handleExpand();
                                        }}
                                    >
                                        OK
                                    </button>
                                </div>
                                <div className="col-6 jcc">
                                    <button type="button" className="btn btn-md btn-primary btn-block" onClick={this.togglePopup}>Cancel</button>
                                </div>
                            </div>
                        </div>
                    </Popup>
                )}
            </div>
        );
    }
}

PlayerLookupInputV2.propTypes = {
    name: PropTypes.string,
    selectClass: PropTypes.string,
    parentClass: PropTypes.string,
    playerOptions: PropTypes.objectOf(any).isRequired,
    isReadOnly: PropTypes.bool,
    showBye: PropTypes.bool,
    position: PropTypes.string,
    onSelect: PropTypes.func,
    utrByMemberId: PropTypes.func,
    showTeamName: PropTypes.bool,
    teamName: PropTypes.string,
    warnBeforePlayerChange: PropTypes.string,
    isMobile: PropTypes.bool,
    PTTPosition: PropTypes.string,
    PTTError: PropTypes.string,
    drawId: PropTypes.string,
};

PlayerLookupInputV2.defaultProps = {
    name: '',
    selectClass: '',
    parentClass: '',
    isReadOnly: false,
    showBye: false,
    position: '',
    onSelect: () => {},
    utrByMemberId: () => {},
    showTeamName: false,
    teamName: '',
    warnBeforePlayerChange: '',
    isMobile: false,
    PTTPosition: '',
    PTTError: '',
    drawId: '',
};

export default PlayerLookupInputV2;
